import { Injectable } from '@angular/core';
import { Environment } from 'src/app/core/interfaces/environment.interface';

@Injectable()
export class EnvironmentService {
  private environment: Environment | null = null;

  async initializeEnvironment(): Promise<void> {
    if (this.environment) {
      return; // Skip initialization if already done
    }

    try {
      const config = await this.fetchConfig();
      const environmentFiles = this.getEnvironmentImports();

      const activeEnvironment =
        typeof config.environment !== 'undefined'
          ? config.environment
          : 'default';

      const environmentModule = await (
        environmentFiles[activeEnvironment] || environmentFiles.default
      )();

      this.environment = environmentModule.environment;
    } catch (error) {
      console.error('Failed to load environment configuration:', error);
      throw error;
    }
  }

  getEnvironment(): Environment {
    if (!this.environment) {
      throw new Error('Environment not loaded yet.');
    }
    return this.environment;
  }

  async fetchConfig() {
    return await fetch('/assets/config.json').then((response) =>
      response.json()
    );
  }

  getEnvironmentImports() {
    return {
      prod: () => import('../../../environments/environment.prod'),
      uat: () => import('../../../environments/environment.uat'),
      develop: () => import('../../../environments/environment.develop'),
      default: () => import('../../../environments/environment.default'),
    };
  }

  isInitialized(): boolean {
    return !!this.environment;
  }
}
